/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse, 
  HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { Dashboard } from '../models/dashboard';
import { Export } from '../models/export';
import { TypeAny } from '../models/type-any';


@Injectable()
export class DashboardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param year - undefined
   */
  getDashboardResponse(year?: number): Observable<HttpResponse<Dashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (year != null) __params = __params.set("year", year.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/admin/dashboard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: Dashboard = null;
        _body = _resp.body as Dashboard
        return _resp.clone({body: _body}) as HttpResponse<Dashboard>;
      })
    );
  }

  /**
   * @param year - undefined
   */
  getDashboard(year?: number): Observable<Dashboard> {
    return this.getDashboardResponse(year).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - set Input object
   */
  exportResponse(body?: TypeAny): Observable<HttpResponse<Export>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/admin/dashboard/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: Export = null;
        _body = _resp.body as Export
        return _resp.clone({body: _body}) as HttpResponse<Export>;
      })
    );
  }

  /**
   * @param body - set Input object
   */
  export(body?: TypeAny): Observable<Export> {
    return this.exportResponse(body).pipe(
      map(_r => _r.body)
    );
  }
}

export module DashboardService {
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/services/dashboard.service.ts